import { LayoutFragment, PageWithUrlFragment, TranslationDomainFragment } from "../model/fragments"
import { fetchGet } from "./fetchWrapper"

export type LayoutProps = {
    layout: LayoutFragment,
    pages: PageWithUrlFragment[],
    translations: TranslationDomainFragment
}


const cache: { [prop: string]: LayoutProps } = {}
export const getLayoutProps = async (locale: string): Promise<LayoutProps> => {

    if(!cache[locale]) {
        cache[locale] = await fetchGet('/layout', new URLSearchParams({locale: locale})) as LayoutProps;
    }

    return cache[locale];
}   
